/** Settings › Connections › Browsers: browser rows, their chips and help. */
export default {
  sectionTitle: "Browsers",
  sectionIntro: "Connect lets Denker read and use browser pages.",
  catalogNeedsNewerBuild: "Other browsers need a newer Denker build.",
  catalogReadFailed: "Could not read installed browsers.",

  laneTitle: "Run web tasks in",
  laneYours: "Your browser",
  laneDenker: "Denker browser",
  laneYoursLine:
    "Web tasks run in the browser you have open, else your default browser",
  laneDenkerLine:
    "Web tasks run in Denker's own browser window, in the background",
  laneReadFailed: "Could not read the browser setting.",
  denkerBrowserTitle: "Denker browser",
  denkerBrowserReady: "Ready - opens when a task needs it",
  denkerBrowserCheckFailed: "Could not check the Denker browser",
  denkerBrowserNeedsChromium: "Needs Google Chrome, Microsoft Edge or Brave",
  otherSetupRunning: "Another browser's setup is running",
  actionSetUp: "Set up",
  popupsTitle: "Close cookie banners and pop-ups",
  popupsLine:
    "On pages Denker opens, it refuses cookies, or hides a cookie banner that has no Refuse button, and closes pop-ups that cover the page. A notice tells you; nothing is read aloud.",
  popupsReadFailed: "Could not read this setting.",

  chipExtension: "Extension",
  chipAppleEvents: "Apple Events",
  chipTooltip: "{name}: {does}",
  reconnect: "Reconnect",
  disconnect: "Disconnect",
  stop: "Stop",

  troubleshooting: "Troubleshooting",
  troubleshootingExtensionMac:
    "For Chrome, Edge, Brave, Arc and Dia, choose Connect on the Extension chip: Denker opens the Denker extension’s Chrome Web Store page, where you add it.",
  troubleshootingExtensionWindows:
    "For Chrome, Edge, Brave and Arc, choose Connect on the Extension chip: Denker opens the Denker extension’s Chrome Web Store page, where you add it.",
  troubleshootingTurnedOff:
    "Turned off in the browser: turn the Denker extension back on in its extensions list. Waiting for you to agree: choose Agree and continue on the Denker welcome page.",
  troubleshootingAfterUpdate:
    "The Denker extension connects while its browser is open and Denker is running. If it stays not connected after an update, restart the browser; each time Denker starts, it registers the extension’s connection again.",
  troubleshootingAppleEvents:
    "For Safari, or Apple Events you start from their chip: if Connect needs help, choose Guide me beside the browser.",
  troubleshootingPermissions:
    "In macOS System Settings → Privacy & Security, allow Denker under Automation and Accessibility.",
  troubleshootingScripting:
    "Browser-wide scripting also lets other apps you approve in Automation read and change pages.",

  statusConnected: "Connected",
  statusConnecting: "Connecting…",
  statusDisconnecting: "Disconnecting…",
  statusChecking: "Checking…",
  statusUnknown: "Connection unknown",
  statusDisconnected: "Disconnected",
  statusNotInstalled: "Not installed",
  statusNeedsApproval: "Access needs approval",
  statusBrowserClosed: "{browser} is closed",
  statusPageUnavailable: "Browser page unavailable",
  statusBrowserBusy: "Browser busy",
  statusJavascriptOff: "JavaScript access is off",
  statusRestartRequired: "Browser restart required",
  statusUnavailable: "Connection unavailable",
  statusCheckFailed: "Could not check connection",
  statusExtensionNotConnected: "Extension not connected",
  statusDeveloperModeOff: "Developer mode is off",
  statusExtensionOff: "Extension is off",
  statusTurnedOff: "Turned off in the browser",
  statusExtensionNotAdded: "Extension not added",
  statusExtensionNotSetUp: "Extension not set up",
  statusExtensionOutdated: "Extension out of date",
  statusWaitingConsent: "Waiting for you to agree",

  actionConnect: "Connect",
  actionGuideMe: "Guide me",
  actionRestartDia: "Restart Dia and connect",

  doesConnect: "connect",
  doesGuideMe: "guide me",
  doesRestartDia: "restart Dia and connect",
  doesTurnOn: "turn on",
  doesUpdatesItself: "the browser updates it; a restart applies a waiting update",
  doesAgreeInBrowser: "agree in the browser",
  doesShowWelcome: "show the welcome page",
  doesConnected: "connected",
  doesStop: "stop",
  doesConnecting: "connecting…",
  doesDisconnecting: "disconnecting…",
  doesNotAvailableHere: "not available here",
  whyAnotherConnecting: "another browser is connecting",
  whyNotInstalled: "{browser} is not installed",
  whyNoSetup: "setup isn't offered in this build",
  whyOtherSetup: "another browser's setup is running",

  helpDiaRestart:
    "Denker will close and reopen Dia to enable access. Complete any save prompt in Dia.",
  helpDiaRestartFailed:
    "Dia’s restart could not be completed. Try connecting again.",
  helpPageFailed: "Denker could not open a browser page. Try connecting again.",
  helpPageAutomatic: "Connect opens a browser page automatically.",
  helpBrowserNotOpened: "{browser} could not be opened. Try again.",
  helpAllowJavascript:
    "{browser} requires your click on Allow JavaScript from Apple Events. Denker will check access automatically.",
  helpAccessibility: "Allow Denker in macOS Accessibility to continue.",
  helpAutomation: "Approve browser access in macOS to continue.",
  helpApproval: "Finish the browser’s approval, or let Denker guide you.",
  helpClosedDuringSetup: "{browser} closed during setup. Try connecting again.",
  helpBusy: "The browser is busy. Try connecting again when it’s finished.",
  helpUncertain: "Connection could not be verified. Try connecting again.",
  helpUnsupported: "Automatic setup is unavailable for this browser.",
  errorSessionUnavailable:
    "Browser connection is unavailable. Reopen Settings to try again.",
  errorExtensionUnreachable:
    "Denker could not reach the extension's connection. Try again.",
  errorExtensionNoAnswer:
    "The Denker extension in {browser} did not answer. Open {browser} and try again.",
} as const;
